import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';

import { EKYCService } from '../../_services/ekyc.service';
import { ThemeService } from 'src/app/_services/theme.service';
import { SecurityService } from 'src/app/_services/security.service';
import { LogService } from 'src/app/_services/log.service';

import { environment } from 'src/environments/environment';
import { KYCStatusRequestViewModel, KYCStatusResponseViewModel } from '../_models/KYCStatusViewModel';
import { KYCReSubmissionModel } from '../_models/KYCReSubmissionModel';

@Component({
  selector: 'ekyc-showmsg',
  templateUrl: './showmsg.component.html',
  styleUrls: ['./showmsg.component.scss'],
  standalone: false
})
export class ShowMsgComponent implements OnInit {

  // UI related
  bgClass = '';
  header = 'Notification';
  message = environment.Generic_Error_Message;
  btnText = 'Home';

  // Flags
  showCommonMsg = false;
  showSQFail = false;
  showSQSuccess = false;
  showLinkExpired = false;
  genericerr = false;
  browsernotsupport = false;
  showRetryMessage = false;
  linkExpireMessage = false;

  // Inputs
  kycShowMsg: string;
  refNo: string;
  device: string = '';
  refId: string;

  // Error flags
  nonmobiledevice = false;
  error9820 = false;
  error9822 = false;
  error9200 = false;
  error9100 = false;
  error9210 = false;
  error9300 = false;
  error9400 = false;
  error9800 = false;
  error9801 = false;
  error9810 = false;
  error9835 = false;
  error621 = false;

  kycStatus: KYCStatusResponseViewModel;
  subscription = new Subscription();

  constructor(
    private ekycService: EKYCService,
    private route: ActivatedRoute,
    private securityService: SecurityService,
    private logService: LogService,
    public themeservice: ThemeService,
    public router: Router
  ) {
    this.bgClass = this.themeservice.getMake();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.refNo = params["id"];
      this.device = params["device"];
      this.kycShowMsg = (params["msg"] || '').toLowerCase();
    });

    // if (this.refNo) {
    //   forkJoin([this.securityService.updateJWTToken("eKYC")]).subscribe(([success]) => {
    //     if (success) {
    //       this.validateData();
    //     }
    //   });
    // }

    if(this.refNo && !this.securityService.isTokenExpired("eKYC")){
      this.validateData();
    }

    this.setMessageContent(this.kycShowMsg);
  }

  setMessageContent(code: string): void {
    const errorMessages = new Map<string, { header: string, message: string, btnText?: string }>([
      ['sqsuccess', {
      header: 'Verification Successful.',
      message: 'Continue your e-Application journey from your desktop by clicking on the eKYC link in the email you received earlier. Thank you.',
      btnText: 'Close'
    }],
    ['ocrrecycle', {
      header: 'Retry.',
      message: 'Identity Card/ Passport Unsupported. Please use your original document and retake the photos to proceed with your application.',
      btnText: 'Retry'
    }],
    ['ocrexpired', {
      header: 'Error 113.',
      message: 'Your e-Verification link has expired. You may require to restart the application by clicking on the application link in the email you received earlier.',
      btnText: 'Close'
    }],
    ['sqfail', {
      header: 'Error 104.',
      message: 'We are unable to proceed with your application. Please contact Customer Interaction Center at +603-27192688 for further assistant.',
      btnText: 'Close'
    }],
    ['stopsq', {
      header: 'Error 102.',
      message: 'We are unable to proceed with your application. Please contact Customer Interaction Center at +603-27192688 for further assistant.',
      btnText: 'Close'
    }],
    ['sqiderror', {
      header: 'Your e-verification process failed.',
      message: 'We are unable to proceed with this application. Please start a new application. Contact Customer Interaction Center at +603-27192688 for assistant.'
      
    }],
    ['linkexpired', {
      header: 'Session Expired.',
      message: 'Your session has timed out for security reasons. Please click Continue Application to proceed with your application.',
      btnText: 'Continue Application',
    }],
    ['genericerr', {
      header: 'Error.',
      message: environment.Generic_Error_Message
    }],
    ['browsernotsupport', {
      header: 'Browser Not Supported.',
      message: 'Please use the default browser for your operating system and ensure you have enabled camera access permission.'
    }],
    ['nonmobiledevice', {
      header: 'Environment Not Supported.',
      message: 'This feature requires a smartphone camera to function. Please switch to a mobile device to proceed.'
    }],
    ['error100', {
      header: 'Error 100.',
      message: 'We are unable to process your online request at this time. Please try again later.'
    }],
    ['error103', {
      header: 'Error 103.',
      message: 'One More Try, You will have another attempt to submit your document.'
    }],
    ['error104', {
      header: 'Error 104.',
      message: 'We are unable to proceed with your application as we are unable to verify your identity. Please start a new application again or visit your nearest branch.'
    }],
    ['error105', {
      header: 'Error 105.',
      message: 'Please try again in the next 24 hours. You have exceeded the maximum number of verification attempts.'
    }],
    ['error106', {
      header: 'Error 106.',
      message: 'We are unable to proceed with your application due to document verification failure. Please restart your application.'
    }],
    ['error107', {
      header: 'Error 107.',
      message: 'We are unable to proceed with your application as your identity document could not be verified. Please start a new application.'
    }],
    ['error108', {
      header: 'Error 108.',
      message: 'We are unable to proceed with your application. Please ensure you are using a valid and readable ID.'
    }],
    ['error109', {
      header: 'Error 109.',
      message: 'Identity Card / Passport not readable. Please retake the photos clearly and ensure all details are visible.'
    }],
    ['error110', {
      header: 'Error 110.',
      message: 'Identity Card/ Passport Unsupported. Please restart the application with a supported identity document.',
      btnText: 'Start New Application'
    }],
    ['error405', {
      header: 'Error 405.',
      message: 'Please try again using the link in your email in 1 hour. We are currently unable to complete your request.'
    }],
    ['error402', {
      header: 'Error 402.',
      message: 'Please try again later using the link in your email. Your session was terminated unexpectedly.'
    }],
    ['error9820', {
      header: 'Browser Settings Not Supported.',
      message: 'Access may not have been granted to your gallery. Please check your browser permissions and try again.'
    }],
    ['error9822', {
      header: 'Browser Not Supported.',
      message: 'Please use the default browser for your operating system and ensure you have enabled camera access permission.'
    }],
    ['error9200', {
      header: 'Session Has Expired.',
      message: 'Please click on the link within the email you received to restart your application.'
    }],
    ['error9100', {
      header: 'Connection Lost.',
      message: 'The connection to our partner may have been lost. Please try again later by clicking on the application link in the email you received earlier.'
    }],
    ['error9210', {
      header: 'Session Has Expired.',
      message: 'Please click on the link within the email you received to restart your application.'
    }],
    ['error9300', {
      header: 'Connection Lost.',
      message: 'Please try again later by clicking on the link in the email you received earlier to continue with your application.'
    }],
    ['error9400', {
      header: 'Verification Failed.',
      message: 'An unexpected error occurred during our verification process. Please try again later or contact support.'
    }],
    ['error9800', {
      header: 'Connection Lost.',
      message: 'The connection to our partner may have been lost. Please try again later.'
    }],
    ['error9801', {
      header: 'Unexpected Error.',
      message: 'An unexpected error occurred during our verification process. Please try again later.'
    }],
    ['error9810', {
      header: 'Connection Lost.',
      message: 'The connection to our partner may have been lost. Please try again later.'
    }],
    ['error9835', {
      header: 'Image Clarity Insufficient.',
      message: 'The images taken may not be clear enough for verification. Please retake the photos and ensure they are in focus and well-lit.'
    }],
    ['error621', {
      header: 'Service Error.',
      message: 'The connection to our partner may have been lost. Please try again later.'
    }]
  ]);

    const content = errorMessages.get(code);
    if (content) {
      this.header = content.header;
      this.message = content.message;
      this.btnText = content.btnText || this.btnText;
    }
  }

  validateData(): void {
    if (!this.refNo) return;

    const request = new KYCStatusRequestViewModel();
    request.ScreeningNo = this.refNo;

    this.subscription = this.ekycService.getKYCStatus(request).subscribe(resp => {
      const { data } = resp;

      if (!resp.isSucceed && data.ocrStatusId !== 26 && data.ocrStatusId !== 27 && data.sqStatusId !== 36) {
        this.header = resp.message;
        this.message = resp.messageDetail;
        return;
      }

      if (!resp.isSucceed && data.ocrStatusId === 26 && data.sqStatusId === 36) {
        this.showRetry('Retry.', 'Your e-verification link has expired. Click Retry to start e-Verification again.');
        return;
      }

      if (!resp.isSucceed && data.ocrStatusId === 26) {
        this.showRetry('Retry.', 'Identity Card/ Passport Unsupported. For Malaysian users, please use your original physical Identity Card. For foreign users, please use your original physical Passport.');
        return;
      }

      if (!resp.isSucceed && data.ocrStatusId === 27) {
        this.header = 'Error 113.';
        this.message = 'Your e-verification process failed. Unable to proceed with this application. Please start a new application.';
        this.btnText = 'Home';
        return;
      }

      this.kycStatus = data;
      this.device = data.deviceType;
      this.refId =data.sourceReferenceNo;
      this.logService.setLogRocketUserName(data.customerName, data.customerName);

      if (data.source === 'CFE' && data.deviceType === 'M' && this.kycShowMsg === 'sqsuccess') {
        this.message = 'Please click Proceed to continue your e-Application journey...';
        this.btnText = 'Proceed';
      }
    });
  }

  showRetry(header: string, message: string): void {
    this.header = header;
    this.message = message;
    this.btnText = 'Retry';
    this.showRetryMessage = true;
  }

  reSubmissonKyc(): void {
    if (!this.showRetryMessage) return;

    const model = new KYCReSubmissionModel();
    model.calculationId = 0;
    model.referenceId = this.refNo;
    model.deviceType = 'M';

this.ekycService.reSubmitCustomerScreening(model).subscribe(result => {
  if (result.isSucceed && result.data?.refNo) {
    this.refNo = result.data.token;
    this.navigate('landing');
  } else {
    console.error('ReSubmission Failed', {
      Status: result.message,
      Message: result.messageDetail
    });
  }
});
}

  navigate(path: string, message: string = ''): void {
    this.router.navigate([path], {
      queryParams: { id: this.refNo, device: this.device, msg: message }
    });
  }

  proceed(): void {
     console.log('device:', this.device, 'kycStatus.deviceType:', this.kycStatus?.deviceType);
    if (this.kycStatus && (this.device === 'M' || this.kycStatus.deviceType === 'M')) {
      if (this.kycStatus.source === 'CFE') {
        window.location.href = `${this.themeservice.getEngageURL()}landing?source=CFE&from=kyc&Id=${this.kycStatus.sourceReferenceNo}`;
      } else {
        window.close();
      }
    } else {
      window.location.href = this.themeservice.getEngageURL();
    }
  }

  continueApplication(): void {
  const sourceReferenceNo = this.kycStatus?.sourceReferenceNo || localStorage.getItem('sourceReferenceNo');
  window.location.href = `${this.themeservice.getEngageURL()}landing?source=CFE&Id=${sourceReferenceNo}`;
}

}